import * as React from 'react';
import { PageProps } from 'gatsby';
import Layout from '../components/Layout';
import { EquationContainer } from '../components/Equations/EquationContainer';
import { BatteryRuntimeComponent } from '../components/Equations/BatteryRuntimeComponent';

export default function BatteryRuntimePage(props: PageProps): JSX.Element {
  const pageTitle = 'Battery Runtime';

  return (
    <Layout location={props.location} title={pageTitle}>
      <EquationContainer>
        <BatteryRuntimeComponent />
      </EquationContainer>
    </Layout>
  );
}
